import { Component, input, output } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { UiPalette } from '../../../types/UiPalette.type';

@Component({
  selector: 'eiq-button',
  templateUrl: 'button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent {
  active = input<'active' | 'non-active'>('non-active');
  align = input<'left' | 'center' | 'right'>('center');
  avatar = input<string>();
  color = input<UiPalette>('primary');
  disabled = input<boolean>(false);
  expand = input<'block' | 'full'>('block');
  svgIcon = input<string>();
  icon = input<IconDefinition>();
  iconPosition = input<'left' | 'right'>('left');
  iconColor = input<UiPalette>();
  secondaryIcon = input<IconDefinition>();
  secondaryIconPosition = input<'left' | 'right'>('left');
  secondaryIconColor = input<UiPalette>();
  size = input<'large' | 'medium' | 'small' | 'tiny'>('medium');
  loading = input<boolean>(false);
  loadingText = input<string>('Loading...');
  text = input<string>();
  title = input<string>();
  testId = input<string>();
  style = input<'stroked' | 'flat' | 'icon' | 'basic' | 'fab'>('flat');
  background = input<'transparent' | 'initial'>('initial');

  clicked = output<void>();
}
